<ng-container *ngIf="isCreateMode() || isUpdateMode()">
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header
      [mode]="mode"
      createLabel="Ajouter un contact interne"
      [updateLabel]="form.get('firstName').value + ' ' + form.get('lastName').value?.toUpperCase()"
    ></base-form-header>

    <mat-dialog-content fxLayout="column">
      <div class="flex flex-col sm:flex-row">
        <base-form-input
          class="sm:mr-3 sm:w-1/2"
          label="Nom"
          controlName="lastName"
          [icon]="icPerson"
        ></base-form-input>

        <base-form-input
          class="sm:ml-3 sm:w-1/2"
          label="Prénom"
          controlName="firstName"
          [icon]="icPerson"
        ></base-form-input>
      </div>

      <base-form-input
        [items]="contactType"
        label="Rôles utilisateur"
        type="multiple"
        controlName="contactType"
        displayProperty="label"
      ></base-form-input>

      <form-list-phone-input
        [form]="form"
        [fb]="fb"
        [isUpdateMode]="isUpdateMode()"
        [contact]="defaults"
      ></form-list-phone-input>

      <base-form-input label="Email Microsoft" controlName="mcEmail" [icon]="icEmail"></base-form-input>

      <base-form-input label="Email" controlName="email" [icon]="icEmail"></base-form-input>

      <!--            <base-form-input-->
      <!--                    label='ID Docuware'-->
      <!--                    controlName='idDocuware'>-->
      <!--            </base-form-input>-->

      <!--           TODO: Delete this part if role work for predik

             <base-form-input-->
      <!--                label='Rôle'-->
      <!--                type='multiple'-->
      <!--                controlName='roles'-->
      <!--                [loading]='loading'-->
      <!--                [items]='temporayRole'>-->
      <!--            </base-form-input>-->

      <!--            <mat-form-field class="flex-auto w-full">-->
      <!--                <mat-label>Niveau de validation</mat-label>-->
      <!--                <mat-select formControlName="validatorMatriceLevel">-->
      <!--                    <mat-option *ngFor='let level of levels' [value]="level">{{ levelTranslation(level) }}</mat-option>-->
      <!--                </mat-select>-->
      <!--                <mat-error *ngIf="form.controls['validatorMatriceLevel'].errors?.required">Le champ Niveau de validation-->
      <!--                    est obligatoire-->
      <!--                </mat-error>-->
      <!--            </mat-form-field>-->

      <base-form-input
        *ngIf="authService.currentUserValue().isPredik"
        label="Predik"
        controlName="isPredik"
        type="checkbox"
      ></base-form-input>

      <base-form-input
        label="Affectation à tous les établissements"
        controlName="affectAllEstablishments"
        type="checkbox"
        (onChangeCheckBox)="onAffectAllEstablishmentsChange($event)"
      ></base-form-input>

      <div *ngIf="!form.get('affectAllEstablishments').value">
        <div class="flex flex-col sm:flex-row w-full items-center gap-4 mb-4">
          <button mat-raised-button color="primary" type="button" (click)="addAffectation()">
            <mat-icon>add</mat-icon>
            Ajouter une affectation
          </button>
        </div>

        <div
          *ngIf="selectedAffectations.length > 0"
          class="establishments-container mat-elevation-z1"
          style="
            max-height: 320px;
            overflow-y: auto;
            background-color: #fafafa;
            border-radius: 4px;
            padding: 12px;
            margin-bottom: 16px;
          "
        >
          <div *ngFor="let affectation of selectedAffectations; let i = index" class="establishment-row">
            <div class="establishment-fields-row" fxLayout="row" fxLayoutAlign="start center">
              <mat-form-field appearance="fill" class="flex-auto">
                <mat-label>Établissement</mat-label>
                <input
                  matInput
                  [matAutocomplete]="autoEstablishment"
                  [(ngModel)]="selectedAffectations[i].establishment.label"
                  [ngModelOptions]="{ standalone: true }"
                  name="establishment_{{ i }}"
                  (input)="establishmentAutocompleteChange($event.target.value, i)"
                  (focus)="establishmentAutocompleteChange($event.target.value, i)"
                />
                <mat-autocomplete
                  #autoEstablishment="matAutocomplete"
                  (optionSelected)="onEstablishmentSelect($event, i)"
                >
                  <mat-option
                    *ngFor="let est of filteredEstablishments[i] || []"
                    [value]="est.label"
                    [attr.data-id]="est._id"
                  >
                    {{ est.label }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <button class="mb-6" mat-icon-button color="warn" type="button" (click)="removeAffectation(i)">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <base-form-input
        type="submit"
        [mode]="mode"
        entityLabel="USER"
        [loading]="loading"
        (onCreate)="createItem()"
        (onUpdate)="updateItem()"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>

<ng-container *ngIf="isDeleteMode()">
  <form-modal-delete-base
    [label]="data.name"
    [loading]="loading"
    (onDelete)="deleteItem()"
    (onClose)="close()"
  ></form-modal-delete-base>
</ng-container>
<ng-container *ngIf="isArchiveMode()">
  <form-modal-delete-base
    (onClose)="close()"
    (onDelete)="archiveItem()"
    title="Archiver le contact interne"
    defaultMessage="Êtes-vous sûr de vouloir archiver ce contact interne ?"
  ></form-modal-delete-base>
</ng-container>

<ng-container *ngIf="isImportMode()">
  <vex-form-import-base
    [modalTitle]="'Importer des contacts internes'"
    [entityLabel]="'Annuaire'"
    [form]="importForm"
    [loading]="loading"
    [service]="service"
    [mode]="mode"
    (saveForm)="save()"
    (importItems)="importItems()"
    [canDownloadTemplateModel]="true"
  ></vex-form-import-base>
</ng-container>
